// extracted by mini-css-extract-plugin
export default {"aplicacion":"Aplicacion_aplicacion__WNFSy"};